import { environment } from '../../environments/environment';
import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularMaterialService, ErrorParseService, LGEDataService } from 'src/commons';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ForgotPasswordComponent implements OnInit {
  forgotPasswordFormGroup: FormGroup;

  constructor(
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private ams: AngularMaterialService,
    private errorParse: ErrorParseService,
    private lgeDataService: LGEDataService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.createForms();
  }

  ngOnInit() { }

  sendLink() {
    this.ams.showLoader('Please wait...');
    let email = this.forgotPasswordFormGroup.value;
    this.lgeDataService.externalUserStatusCheckMVC(email.email).subscribe(
      {
        next: (result) => {
          this.ams.closeDialog();
          if (result && +result > 0) {
            if (+result < 2) {
              this.lgeDataService.forgotPassword(email).subscribe({
                next: () => {
                  this.ams.closeDialog();
                  this.ams.showAlert('Email Sent', 'The link sent to your email will be valid for 15 minutes', true);
                },
                error: error => {
                  this.ams.closeDialog();
                  this.ams.showAlert('Error!', error.message);
                  this.ref.markForCheck();
                }
              })
            } else {
              this.ams.showAlert('Error!', 'Initial password set up has not been done for this account!');
            }
          } else {
            this.ams.showAlert('Error!', 'Your account has not been Approved by Admin');
          }
        },
        error: error => {
          this.ams.closeDialog();
          this.ams.showAlert('Incorrect email ! ', `Please contact contributions@lge-ku.com with questions.
          \n${error.message}`)
          this.ref.markForCheck();
        }
      }
    )
  }

  private createForms(): void {
    this.forgotPasswordFormGroup = this.fb.group({
      email: ['', [Validators.required, Validators.minLength(3), Validators.pattern(new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/))]]
    });
  }

  displayLoader(pending: boolean): void {
    if (pending) {
      this.forgotPasswordFormGroup.disable();
      this.ams.showLoader("Saving");
    } else {
      this.forgotPasswordFormGroup.enable();
      this.ams.closeDialog().then(() => {
        // if (this.error !== null && this.error !== undefined && this.error !== '') {
        //   this.displayError(this.error);
        // }
      });
    }
  }

  private displayError(error: any): void {
    let errorMessage;
    if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
      errorMessage = this.errorParse.translateCCError(error);
    } else {
      errorMessage = error instanceof Object ? error.message : error;
    }
    this.ams.showAlert("Error", errorMessage);
    this.forgotPasswordFormGroup.reset();
  }
}